






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class LoadingMoreSpinner extends Vue {
	@Prop({ default: false, required: true }) private loading;

	private loadingData = false;

	@Watch('loading')
	loadingChange(value) {
		this.loadingData = value;
	}

	mounted() {
		if (this.loading) {
			this.loadingData = this.loading;
		}
	}
}
